import {
  Button,
  Flexbox,
  Icons,
  Sizes,
  Text,
} from '@sede-enterprise/shell-ds-react-framework';
import { AlertContainer } from 'components/Alert/Alert.styles';
import { useEffect } from 'react';
import { useStore } from 'store';

const { AlertCircle, AlertExclamationMark, InfoCircle, CheckCircle, Cross } =
  Icons;

const AUTO_CLOSE_DELAY = 30000; // 10 seconds in milliseconds

export const Alert = () => {
  const {
    isVisible,
    sentiment,
    message,
    buttonText,
    buttonAction,
    clearAlert,
  } = useStore((state) => ({
    isVisible: state.alert.visible,
    sentiment: state.alert.sentiment,
    message: state.alert.message,
    buttonText: state.alert.buttonText,
    buttonAction: state.alert.buttonAction,
    clearAlert: state.clearAlert,
  }));

  useEffect(() => {
    const timer = setTimeout(() => {
      clearAlert();
    }, AUTO_CLOSE_DELAY);

    return () => clearTimeout(timer);
  }, [message, clearAlert]);

  const getIcon = () => {
    if (sentiment === 'success') return <CheckCircle />;
    if (sentiment === 'error') return <AlertExclamationMark />;
    if (sentiment === 'info') return <InfoCircle />;
    if (sentiment === 'warning') return <AlertCircle />;
    return <AlertExclamationMark />;
  };
  return (
    <AlertContainer
      data-testid={'alert-banner'}
      sentiment={sentiment}
      isVisible={isVisible}
    >
      {getIcon()}
      <Flexbox justifyContent={'space-between'} alignItems={'center'} flex={1}>
        <Text type={'p'} size={Sizes.Medium}>
          {message}
        </Text>
        {buttonText ? (
          <Button
            variant={'outlined'}
            size={Sizes.Small}
            onClick={buttonAction}
          >
            {buttonText}
          </Button>
        ) : (
          <Button
            variant={'transparent'}
            size={Sizes.Small}
            onClick={clearAlert}
          >
            <Cross />
          </Button>
        )}
      </Flexbox>
    </AlertContainer>
  );
};
